module.exports = __webpack_public_path__ + "img/Fisdomシラバス掲載講師写真.0a682368.png";